import React, { useEffect, useState } from "react";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import hdfc from "../../images/bank1.png";
import grow from "../../images/grow.png";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { HiMiniChevronDown, HiMiniChevronUp } from "react-icons/hi2";
import { MdOutlineFileDownload } from "react-icons/md";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import NoDataFound from "../../components/NoDataFound";
import ImageLoading from "../../components/ImageLoading";
import Stocks from "../Stocks/Stocks";

function StockAnalyzer({ id }) {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const lender_id = localStorage.getItem("lender_uuid");

  const [holdingData, setHoldingData] = useState([
    "All Holding",
    "Broker 1",
    "Broker 2",
    "Broker 3",
    "Broker 4",
    "Broker 5",
  ]);
  const [noData, setNoData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [holdingSelected, setHoldingSelected] = useState("All Holding");
  const [openHoldingMore, setOpenHoldingMore] = useState(false);
  const [more, setMore] = useState(false);
  const [expand, setExpand] = useState(false);
  const [expandAnalytics, setExpandAnalytics] = useState(false);
  const [holdingDetails, setHoldingDetails] = useState("");
  const [stocksData, setStocksData] = useState([1, 2, 3, 4, 5, 6]);
  const [showView, setShowView] = useState(false);
  const [showViewAnalytics, setShowViewAnalytics] = useState(false);

  const [singleStocks, setSingleStocks] = useState(false);
  const [stocksId, setStocksId] = useState("");

  const [recordArray, setRecordArray] = useState([]);
  const [noDownload, setNoDownload] = useState(false);

  const fetchRecordId = (assetArray) => {
    let flagArray = [];
    assetArray.forEach((item) => {
      flagArray = [...flagArray, ...item.record_ids];
    });
    setRecordArray(flagArray);
  };

  const fetchAssetGateway = async () => {
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/users/${id}/asset_gateway`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      if (res?.data?.asset_gateway?.stocks?.length > 0) {
        fetchRecordId(res.data.asset_gateway.stocks);
      } else {
        setNoDownload(true);
      }
    } catch (error) {}
  };

  const stocksDataHolding = async () => {
    setLoading(true);
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/stocks_details/${lender_id}?user_id=${id}`,
        method: "GET",
        headers: { Authorization: token, "Content-Type": "application/json" },
      };
      const res = await axios(options);
      if (res?.data?.stocks_details !== null) {
        setHoldingDetails(res.data);
        fetchAssetGateway();
        setNoData(false);
        setLoading(false);
      } else {
        setHoldingDetails("");
        setNoData(true);
        setLoading(false);
      }
    } catch (error) {
      setHoldingDetails("");
      setNoData(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    stocksDataHolding();
  }, []);

  function truncateText(text, maxLength) {
    if (text === null) return "---";
    if (text.length > maxLength) {
      return text.slice(0, maxLength - 3) + "...";
    }
    return text;
  }

  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "--";
    return num.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
    });
  }

  const handleExcelDownload = async (assetName) => {
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/users/${id}/download_as_excel`,
        method: "POST",
        headers: { Authorization: token },
        data: {
          asset_name: assetName,
          record_ids: recordArray,
        },
      };
      const res = await axios(options);
      if (res.data.url.status) {
        const url = res.data.url.data;
        handleDownloadFile(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const handleDownloadFile = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ""); // 'download' attribute triggers download
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <>
      {noData && (
        <div className="w-full h-[calc(100vh-190px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <NoDataFound />
        </div>
      )}
      {loading && (
        <div className="w-full h-[calc(100vh-190px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <ImageLoading />
        </div>
      )}
      {!noData && !loading && (
        <>
          {!singleStocks ? (
            <div className=" mt-4 w-full overflow-auto h-[calc(100vh-190px)]">
              <div className="flex flex-row justify-between gap-2">
                <div className="flex flex-col justify-between gap-3 w-[49.4%] h-full">
                  <div
                    className={`bg-white rounded-lg w-full p-3 ${
                      expand ? "h-fit" : "h-fit"
                    }`}
                  >
                    <p className="text-[#262626] font-semibold text-base">
                      Stock Holding
                    </p>
                    <div
                      className={`${
                        expand && holdingDetails?.stocks_details?.length > 5
                          ? "overflow-y-scroll h-[60vh]"
                          : expand &&
                            holdingDetails?.stocks_details?.length <= 5
                          ? "overflow-y-scroll h-fit"
                          : !expand &&
                            holdingDetails?.stocks_details?.length > 3
                          ? "overflow-y-hidden h-[292px]"
                          : "overflow-y-hidden h-fit"
                      }`}
                    >
                      {holdingDetails &&
                        holdingDetails?.stocks_details?.length > 0 &&
                        holdingDetails.stocks_details.map((item) => {
                          return (
                            <div
                              className="mt-4 flex flex-row justify-between items-center border border-solid border-[#E6EBED] p-3 rounded-lg hover:shadow-lg cursor-pointer"
                              // onClick={() => {
                              //   setSingleStocks(true);
                              //   setStocksId(item.isinno);
                              // }}
                            >
                              <img
                                src={hdfc}
                                width="45"
                                height="45"
                                alt="hdfc"
                                className=""
                              />
                              <div className="flex basis-[50%] ml-3">
                                <p className="text-xs font-semibold text-[#262626]">
                                  {truncateText(item.isinDescription, 35) ||
                                    "---"}
                                </p>
                                {/* <div className="flex flex-row justify-start items-center gap-1">
                        <p className="text-xs font-medium text-[#262626]">
                          Price: &#8377;235{" "}
                        </p>
                        <HiMiniChevronDown color="#D30D00" size={"15px"} />
                        <p className="text-xs font-medium text-[#D30D00]">
                          -1.25 &#37;
                        </p>
                      </div> */}
                              </div>
                              <div className="flex flex-col justify-start items-start mr-auto gap-1">
                                <p className="text-xs font-medium text-[#8B8B8B]">
                                  Quantity
                                </p>
                                <p className="text-xs font-medium text-[#262626]">
                                  {item.units}
                                </p>
                              </div>
                              <div className="flex flex-col justify-start items-start gap-1">
                                <p className="text-xs font-medium text-[#8B8B8B]">
                                  Current Value
                                </p>
                                <p className="text-xs font-medium text-[#262626]">
                                  {formatToIndianRupees(item.price) || "--"}
                                </p>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                    {holdingDetails &&
                      holdingDetails.stocks_details &&
                      holdingDetails.stocks_details.length > 3 && (
                        <div className="flex flex-row justify-center items-center mt-4">
                          {expand ? (
                            <p
                              className="text-xs font-semibold text-[#262626] cursor-pointer"
                              onClick={() => setExpand(false)}
                            >
                              Less
                            </p>
                          ) : showView ? (
                            <p
                              className="text-xs font-semibold text-[#262626] cursor-pointer"
                              onClick={() => setExpand(true)}
                              onMouseOut={() => setShowView(false)}
                            >
                              View More
                            </p>
                          ) : (
                            <HiMiniChevronDown
                              className="cursor-pointer rounded-full border border-solid border-[#262626] animate-bounce"
                              color="#262626"
                              size={"25px"}
                              onMouseOver={() => setShowView(true)}
                            />
                          )}
                        </div>
                      )}
                  </div>
                  <div className={`bg-white rounded-lg full p-3 h-[120px]`}>
                    <p className="text-[#262626] font-semibold text-base">
                      Downloads
                    </p>
                    <div className="mt-4 flex flex-row justify-between items-center border border-solid border-[#E6EBED] p-3 rounded-lg">
                      <div className="flex flex-row justify-start items-center mr-auto ml-3">
                        <p className="text-xs font-semibold text-[#262626]">
                          Stock Portfolio Anaysis
                        </p>
                      </div>
                      <div className="flex flex-row justify-start items-start">
                        <button
                          onClick={() => {
                            handleExcelDownload("stocks");
                          }}
                          className={`px-4 py-1 flex flex-row items-center gap-2 rounded bg-white text-xs font-semibold text-[#00394d] border border-solid border-[#00394D]`}
                        >
                          <MdOutlineFileDownload
                            size={"20px"}
                            color="#00394D"
                          />
                          Download
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`bg-white rounded-lg w-[49.4%] p-3 ${
                    expandAnalytics ? "h-fit" : "h-fit"
                  }`}
                >
                  <p className="text-[#262626] font-semibold text-base">
                    Analytics
                  </p>
                  <div className="flex flex-row justify-between items-center gap-3 mt-4">
                    <div className="flex flex-row justify-between items-start border border-solid border-[#E6EBED] p-3 rounded-lg basis-[50%]">
                      <div className="flex flex-col justify-start items-start gap-3">
                        <p className="text-xs font-bold text-[#262626]">
                          Total Current Value
                        </p>
                        <p className="text-lg font-semibold text-[#00394D]">
                          {formatToIndianRupees(
                            holdingDetails?.total_value?.asset_value
                          ) || "--"}
                        </p>
                      </div>
                      <IoMdInformationCircleOutline
                        size={"20px"}
                        color="#262626"
                      />
                    </div>
                    <div className="flex flex-row justify-between items-start border border-solid border-[#E6EBED] p-3 rounded-lg basis-[50%]">
                      <div className="flex flex-col justify-start items-start gap-3">
                        <p className="text-xs font-bold text-[#262626]">
                          Number of Holding
                        </p>
                        <p className="text-lg font-semibold text-[#00394D]">
                          {holdingDetails?.total_value?.asset_count}
                        </p>
                      </div>
                      <IoMdInformationCircleOutline
                        size={"20px"}
                        color="#262626"
                      />
                    </div>
                  </div>
                  <div
                    className={`w-full mt-3 ${
                      expandAnalytics &&
                      holdingDetails?.stocks_details?.length > 4
                        ? "overflow-y-scroll h-[45vh]"
                        : expandAnalytics &&
                          holdingDetails?.stocks_details?.length <= 4
                        ? "overflow-y-scroll h-fit"
                        : "overflow-y-hidden h-[205px]"
                    }`}
                  >
                    <div className="flex flex-col justify-center items-center border border-solid border-[#E6EBED] p-3 rounded-lg mt-3">
                      <div className="flex flex-row justify-between items-center w-full">
                        <p className="text-xs font-bold text-[#262626]">
                          LTV Ratio
                        </p>
                        <IoMdInformationCircleOutline
                          size={"20px"}
                          color="#262626"
                        />
                      </div>
                      {holdingDetails &&
                        holdingDetails?.stocks_details?.length > 0 &&
                        holdingDetails.stocks_details.map((item, index) => {
                          return (
                            <div
                              key={index}
                              className={`w-full flex flex-row justify-between items-center pt-3 ${
                                holdingDetails?.stocks_details?.length !==
                                  index + 1 &&
                                "border-b border-solid border-[#E6EBED] pb-3"
                              }`}
                            >
                              <img
                                src={hdfc}
                                width="45"
                                height="45"
                                alt="hdfc"
                                className=""
                              />
                              <div className="flex flex-row justify-center items-center mr-auto ml-3">
                                <p className="text-xs font-semibold text-[#262626]">
                                  {truncateText(item.isinDescription, 60) ||
                                    "---"}
                                </p>
                              </div>
                              <div className="flex flex-col justify-center items-end gap-1 text-right">
                                <p className="text-xs font-medium text-[#8B8B8B]">
                                  LTV Ratio
                                </p>
                                <p className="text-xs font-medium text-[#262626]">
                                  {item.ltv ? `${item.ltv}%` : "--"}
                                </p>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                  {holdingDetails?.stocks_details?.length > 2 && (
                    <div className="flex flex-row justify-center items-center mt-5">
                      {expandAnalytics ? (
                        <p
                          className="text-xs font-semibold text-[#262626] cursor-pointer"
                          onClick={() => setExpandAnalytics(false)}
                        >
                          Less
                        </p>
                      ) : showViewAnalytics ? (
                        <p
                          className="text-xs font-semibold text-[#262626] cursor-pointer"
                          onClick={() => setExpandAnalytics(true)}
                          onMouseOut={() => setShowViewAnalytics(false)}
                        >
                          View More
                        </p>
                      ) : (
                        <HiMiniChevronDown
                          className="cursor-pointer rounded-full border border-solid border-[#262626] animate-bounce"
                          color="#262626"
                          size={"25px"}
                          onMouseOver={() => setShowViewAnalytics(true)}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <Stocks
              id={id}
              stocksId={stocksId}
              setSingleStocks={setSingleStocks}
              setStocksId={setStocksId}
            />
          )}
        </>
      )}
    </>
  );
}

export default StockAnalyzer;
